<template>
    <div class="main_div">
        <div style="height: auto" :key="componentKey">
            <n-space>
                <NCard style="margin-top: 20px; margin-left: 80px; border: 0px; min-width: 800px">
                    <n-space item-style="display: flex;" align="center">
                        <div style="font-size: 20px; width: 150px; font-weight: bold">통계 관리</div>
                    </n-space>
                    <div class="content_delimiter_line"></div>
                    <div><p>aaa</p></div>
                </NCard>
            </n-space>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue"; // 필요한 경우 주석 해제
import {
    // NDataTable, // 현재 템플릿에서 사용되지 않음
    NSpace,
    NCard,
    // NSelect, // 현재 템플릿에서 사용되지 않음
    // NDatePicker, // 현재 템플릿에서 사용되지 않음
    // NButton, // 현재 템플릿에서 사용되지 않음
    // NModal, // 현재 템플릿에서 사용되지 않음
} from "naive-ui";
// import { getCallable } from "@/config/env"; // 현재 사용되지 않음
// import * as common from "@/assets/common/common"; // 현재 사용되지 않음
// import * as constant from "@/assets/constant"; // 현재 사용되지 않음
const componentKey = ref(0); // To force re-render if needed
// onMounted(async () => {
//   // mounted 로직이 필요하다면 여기에 작성
// });

// data 속성이 필요하다면 ref 또는 reactive를 사용하여 선언
// 예: const myData = ref(null);

// methods가 필요하다면 일반 함수로 정의
// 예: function myMethod() { /* ... */ }
</script>

<style scope></style>
